import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

const AdminUsers2 = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="wrapper">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <div className="container-fluid ">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
            <h3 className="text-black">Account List</h3>

          <div className="page-title-right"><div className="d-inline-block"><a href="/admin/addClient" className="btn btn-primary"> Add Account</a></div></div>
          </div>

          {/* Export Buttons */}
          <div className="d-flex gap-1 flex-wrap">
            <button className="btn btn-danger bg-red btn-sm">
            <i className="far fa-file-pdf mr-1"></i> PDF
            </button>
            <button className="btn btn-success bg-green btn-sm">
           <i className="far fa-file-excel mr-1"></i> Excel
            </button>
          </div>

          {/* Top Controls */}
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
            <div className="text-black">
              Show{" "}
              <select className="form-select d-inline w-auto py-1 fs-8">
                <option>10</option>
                <option>25</option>
                <option>50</option>
              </select>{" "}
              entries
            </div>

            <div className="d-flex gap-2 ">
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Search..."
              />
              <button className="btn btn-info">Load</button>
              <button className="btn btn-secondary">Reset</button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-light text-nowrap">
                <tr>
                  <th>User Name</th>
                  <th>Credit Reference</th>
                  <th>U st</th>
                  <th>B st</th>
                  <th>Exposure Limit</th>
                  <th>Default (%)</th>
                  <th>Account Type</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-end align-items-center mt-3 gap-2">
            <button className="btn btn-light btn-sm">«</button>
            <button className="btn btn-light btn-sm">‹</button>
            <button className="btn btn-primary btn-sm">1</button>
            <button className="btn btn-light btn-sm">›</button>
            <button className="btn btn-light btn-sm">»</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers2;
